// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/theme.css
// module id = 686
// module chunks = 5